import { render, staticRenderFns } from "./AttachAssociation.vue?vue&type=template&id=97846aa0&"
import script from "./AttachAssociation.vue?vue&type=script&lang=js&"
export * from "./AttachAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports